module.exports = __webpack_public_path__ + "img/blog-9.10f3a0bf.webp";